var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDialog",
    {
      attrs: { visible: _vm.dialogVisible, width: "800px", center: "" },
      on: {
        close: function ($event) {
          _vm.dialogVisible = false
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "140px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ChannelManagement.cron.CardType") } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.orderNeedDelay,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "orderNeedDelay", $$v)
                    },
                    expression: "form.orderNeedDelay",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("ChannelManagement.cron.cardOrder"))),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("ChannelManagement.cron.cardSheet"))),
                  ]),
                  _c("el-radio", { attrs: { label: 3 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("ChannelManagement.cron.ForeverStuck"))
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.form.orderNeedDelay === 1
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("ChannelManagement.cron.Hour") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "290px" },
                      model: {
                        value: _vm.hourText,
                        callback: function ($$v) {
                          _vm.hourText = $$v
                        },
                        expression: "hourText",
                      },
                    },
                    _vm._l(25, function (item) {
                      return _c(
                        "el-option",
                        { key: item - 1, attrs: { value: item - 1 } },
                        [_vm._v(_vm._s(item - 1))]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.form.orderNeedDelay === 2
            ? _c(
                "el-form-item",
                {
                  staticStyle: { "padding-right": "100px" },
                  attrs: { label: "" },
                },
                [
                  _c(
                    "vcrontab",
                    {
                      ref: "vcrontabRef",
                      attrs: { expression: _vm.form.delayRules },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.isSkipWeekend,
                            callback: function ($$v) {
                              _vm.isSkipWeekend = $$v
                            },
                            expression: "isSkipWeekend",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "ChannelManagement.cron.WhetherSkipWeekend"
                              )
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }